<template>
  <v-layout column>
    <v-flex xs12>
      <h4>Booking Review</h4>
    </v-flex>
    <v-flex xs12>
      <v-layout pt-1 row>
        <v-flex xs6 v-if="customerToDriverReview != null">
          <v-layout style="width: 100%" column>
            <p>
              <b>Customer to Driver</b>
            </p>
            <v-rating dense small v-model="customerToDriverReview.rating" readonly></v-rating>
            <p style="font-size: 14px;">{{customerToDriverReview.description}}</p>
          </v-layout>
        </v-flex>
        <v-flex xs6 v-if="driverToCustomerReview != null">
          <p>
            <b>Driver to Customer</b>
          </p>
          <v-rating dense small v-model="driverToCustomerReview.rating" readonly></v-rating>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";

export default {
  name: "booking_review_summary",
  props: {
    bookingForm: Object
  },
  data: function() {
    return {};
  },
  mounted: function() {
    console.log(this.bookingForm.reviews);
  },
  computed: {
    customerToDriverReview: function() {
      if (this.bookingForm.reviews != null) {
        var review = this.bookingForm.reviews.find(function(r) {
          return r.review_type == "customer_to_driver";
        });

        return review;
      }

      return null;
    },
    driverToCustomerReview: function() {
      if (this.bookingForm.reviews != null) {
        var review = this.bookingForm.reviews.find(function(r) {
          return r.review_type == "driver_to_customer";
        });

        return review;
      }

      return null;
    }
  },
  methods: {},
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
